<template>
  <div class="d-version-tips">
    <Dialog
      v-model="isVisible"
      confirmText="去升级"
      :show-footer="true"
      @close="handleClose"
      @confirm="onUpdate"
      :append-to-body="true"
      :z-index="99999999"
    >
      <div class="version-update-content">
        <p class="txt">当前APP版本较低，无法参与该活动，请升级APP到最新版本</p>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/v2-components/dialog'
import Utils from '@/utils/utils'
import { jumpPage } from '@/utils/mUtil'
import { isVersionBigger } from '@/utils/mUtil'
import { mapState } from 'vuex'

export default {
  name: 'VersionDialog',
  components: { Dialog },
  computed: {
    ...mapState(['devicesInfo']),
  },
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    handleClose() {
      this.isVisible = false;
    },
    onUpdate() {
      if (Utils.isAndroid()) {
        MgtvApi.callhandler('checkAppUpdate', {}, () => {})
      } else {
        jumpPage('https://apps.apple.com/app/apple-store/id629774477?pt=355474&ct=jifen&mt=8')
      }
    },
    // 检查版本是否需要更新
    checkVersion() {
      const needUpdate = !isVersionBigger(this.devicesInfo.appVersion);
      if (needUpdate) {
        this.isVisible = true;
      }
      return !needUpdate; // 返回 true 表示版本符合要求，false 表示需要更新
    }
  },
}
</script>

<style lang="less" scoped>
.version-update-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
  margin-bottom: 24px;
  .txt {
    font-weight: 400;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.4);
    line-height: 40px;
    text-align: center;
  }
}
</style>
